/**
 * Helper that renders errors regardless of whether they're
 * a string or an Error object
 */
export const flattenError = (error) => {
    // If the error is undefined, null, or an empty string, don't render
    if (!error)
        return null;
    // Handle strings
    if (typeof error === 'string') {
        return error;
    }
    // Handle Error objects by rerunning against the error's message
    return flattenError(error.message);
};
